// ** Logo
// import logo from "@src/assets/images/favicon.ico"
import themeConfig from "../../../configs/themeConfig"

const SpinnerComponent = () => {
  return (
    <div className="fallback-spinner" style={{
      minHeight: '150px'
    }}>
      {/* <img className="fallback-logo" src={logo} alt="logo" /> */}
      <div className="loading">
        <img src={themeConfig.app.ziploader} />
      </div>
    </div>
  )
}

export default SpinnerComponent
